/* eslint-disable import/no-cycle */
import i18n from '../../i18n/i18n';
import {BaseWidgetConfig} from '../shared/widgets/baseWidgetConfig';
import WidgetSettingFormField from '../shared/widgets/WidgetSettingFormField';
import {ValidationRules} from '../../utils/validationRules';

export class BatchHandlingWidgetConfig extends BaseWidgetConfig {
  // eslint-disable-next-line class-methods-use-this
  get tabs() {
    return [
      {
        key: 'settings',
        label: i18n.t('widget.WidgetSettingsModal.settingConfigTabTitle'),
      },
    ];
  }

  settings = [
    {
      id: 'title',
      label: i18n.t('batchHandling.settings.title.label'),
      helpText: i18n.t('batchHandling.settings.title.help'),
      type: WidgetSettingFormField.fieldTypes.String,
      defaultValue: i18n.t('batchHandling.widget.title'),
      validations: [ValidationRules.required],
    },
  ];
}
